import { Box, Snackbar } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import MockupBanner from '../MockupBanner';
import mockupTheme from '../mockupTheme';
import PublicFooter from './components/PublicFooter';
import PublicHeader from './components/PublicHeader';
import PublicHomePage from './page/PublicHomePage';
import PublicLoginPage from './page/PublicLoginPage';
import PublicSignupPage from './page/PublicSignupPage';
import PublicForgotPasswordPage from './page/PublicForgotPasswordPage';
import PublicResetLinkPage from './page/PublicResetLinkPage';
import PublicVerifyEmailPage from './page/PublicVerifyEmailPage';
import PublicPilotRequestPage from './page/PublicPilotRequestPage';

// Redesign proposals for the public entry and account pages, outside the legacy TopMenuBar.
export default function PublicExperience() {
    const [notice, setNotice] = React.useState<string | null>(null);
    const location = useLocation();

    return (
        <ThemeProvider theme={mockupTheme}>
            <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <MockupBanner surface="Public pages" />
                <Switch>
                    <Route exact path="/mockup/public/signup">
                        <PublicHeader minimal />
                        {/* Keyed by query so switching between the invited and uninvited previews resets the form. */}
                        <PublicSignupPage key={location.search} />
                    </Route>
                    <Route exact path="/mockup/public/pilot">
                        <PublicHeader minimal />
                        <PublicPilotRequestPage />
                    </Route>
                    <Route exact path="/mockup/public/forgot-password">
                        <PublicHeader minimal />
                        <PublicForgotPasswordPage key={location.search} />
                    </Route>
                    <Route exact path="/mockup/public/reset-password">
                        <PublicHeader minimal />
                        <PublicResetLinkPage key={location.search} />
                    </Route>
                    <Route exact path="/mockup/public/verify-email">
                        <PublicHeader minimal />
                        <PublicVerifyEmailPage />
                    </Route>
                    <Route exact path="/mockup/public/login">
                        <PublicHeader minimal />
                        <PublicLoginPage onNotice={setNotice} />
                    </Route>
                    <Route exact path="/mockup/public">
                        <PublicHeader />
                        <PublicHomePage />
                        <PublicFooter />
                    </Route>
                    <Redirect to="/mockup/public" />
                </Switch>
            </Box>
            <Snackbar open={notice !== null} autoHideDuration={3500} onClose={() => setNotice(null)} message={notice ?? ''}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
        </ThemeProvider>
    );
}
